import {
  Button,
  FormLabel,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material"
import { useState, useEffect } from "react"
import {
  getAccountStats,
  getAllExpense,
  getAllIncome,
  getExpenseFilters,
  getExpenseSort,
} from "../../api"
import AddPayment from "../modals/AddPayment"
import FilterSort from "../ui/FilterSort"
import { useSnackbar } from "notistack"
import LoadingContent from "../common/LoadingContent"
import IncomeCard from "../cards/IncomeCard"
import ExpenseCard from "../cards/ExpenseCard"
import dayjs from "dayjs"
import { Box } from "@mui/system"
import { Link } from "react-router-dom"

const CashRegister = () => {
  const { enqueueSnackbar } = useSnackbar()
  const [expenses, setExpenses] = useState([])
  const [incomes, setIncomes] = useState([])
  const endTime = dayjs()
  const startTime = endTime.startOf("day")

  const [loading, setLoading] = useState(false)
  const [accountStats, setAccountStats] = useState({
    openingBalance: {
      bank: 0,
      cash: 0,
    },
    closingBalance: {
      bank: 0,
      cash: 0,
    },
    totalIncome: 0,
    totalExpense: 0,
  })
  const [addPaymentModal, setAddPaymentModal] = useState(false)
  const [filters, setFilters] = useState(null)
  const [sorts, setSorts] = useState(null)

  const fetchFilters = () => {
    getExpenseFilters()
      .then(({ data }) => {
        setFilters(data)
      })
      .catch((err) => console.log(err))
  }

  const fetchSort = () => {
    getExpenseSort()
      .then(({ data }) => setSorts(data))
      .catch((err) => console.log(err))
  }

  const fetchPayments = (options = {}) => {
    setLoading(true)
    getAllExpense(options)
      .then((res) => setExpenses(res.data.rows))
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() =>
        getAllIncome({
          filter: {
            from: options.filter.from,
            to: options.filter.to,
            status: options.filter.status,
            modeOfPayment: options.filter.modeOfPayment,
          },
          sort: options.sort,
        })
          .then((res) => {
            setIncomes(res.data.rows)
          })
          .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
          .finally(() => {
            getAccountStats({
              from: options.filter.from,
              to: options.filter.to,
            })
              .then((res) => {
                console.log(res.data)
                let _stats = {
                  openingBalance: {
                    bank: 0,
                    cash: 0,
                  },
                  closingBalance: {
                    bank: 0,
                    cash: 0,
                  },
                  totalIncome: 0,
                  totalExpense: 0,
                }
                res.data.accountSummary.map((details, index) => {
                  _stats.totalIncome += details.totalIncome
                  _stats.totalExpense += details.totalExpense
                  if (details.type === "CASH") {
                    _stats.openingBalance.cash += details.openingBalance
                    _stats.closingBalance.cash += details.closingBalance
                  }
                  if (details.type === "BANK") {
                    _stats.openingBalance.bank += details.openingBalance
                    _stats.closingBalance.bank += details.closingBalance
                  }
                })
                setAccountStats(_stats)
              })
              .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
              .finally(() => setLoading(false))
          })
      )
  }

  const openAddPayment = () => setAddPaymentModal(true)
  const closeAddPayment = () => setAddPaymentModal(false)

  const refreshPage = () => {
    fetchFilters()
    fetchSort()
    fetchPayments({
      filter: {
        from: startTime.toISOString(),
        to: endTime.toISOString(),
      },
      sort: { field: "creationTimestamp", order: "desc" },
    })
  }

  const [toggle, setToggle] = useState("Income")

  useEffect(() => {
    refreshPage()
  }, [])

  return (
    <>
      <Stack
        direction={{ xs: "col-reverse", sm: "row-reverse" }}
        justifyContent="space-between"
        alignItems={"center"}
        marginBottom={2}
      >
        <FilterSort data={{ filters, sorts }} fetch={fetchPayments} />

        <Stack direction={{ xs: "col", sm: "row" }} spacing={4} gap={1}>
          <Stack
            sx={{
              backgroundColor: "#fff",
              borderRadius: 2,
              px: 5,
              py: 1,
              boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.05);",
            }}
          >
            <FormLabel sx={{ textAlign: "center", fontWeight: 700 }}>
              Opening balance
            </FormLabel>
            <Stack direction="row" spacing={4} marginTop={1}>
              <Stack alignItems={"center"}>
                <FormLabel>Bank</FormLabel>
                <Typography variant="h6" color={"error"}>
                  ₹{accountStats.openingBalance.bank}
                </Typography>
              </Stack>
              <Stack alignItems={"center"}>
                <FormLabel>Cash</FormLabel>
                <Typography variant="h6" color={"green"}>
                  ₹{accountStats.openingBalance.cash}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
          <Stack
            sx={{
              backgroundColor: "#fff",
              borderRadius: 2,
              px: 5,
              py: 1,
              boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.05);",
            }}
          >
            <FormLabel sx={{ textAlign: "center", fontWeight: 700 }}>
              Closing balance
            </FormLabel>
            <Stack direction="row" spacing={4} marginTop={1}>
              <Stack alignItems={"center"}>
                <FormLabel>Bank</FormLabel>
                <Typography variant="h6" color={"error"}>
                  ₹{accountStats.closingBalance.bank}
                </Typography>
              </Stack>
              <Stack alignItems={"center"}>
                <FormLabel>Cash</FormLabel>
                <Typography variant="h6" color={"green"}>
                  ₹{accountStats.closingBalance.cash}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Stack>

        {/* <Stack>
            <FormLabel>Income</FormLabel>
            <Typography variant="h6">{accountStats.totalIncome}</Typography>
          </Stack>
          <Stack>
            <FormLabel>Expense</FormLabel>
            <Typography variant="h6">{accountStats.totalExpense}</Typography>
          </Stack> */}

        <Stack gap={1}>
          {/* <AuthorizedFor roles={[roles.ADMIN, roles.STAFF]}> */}
          {/* <Button
            onClick={openTransferBalance}
            sx={{ mx: "0.5rem" }}
            variant="contained"
          >
            Transfer Balance
          </Button>
          <Button
            onClick={openAddAccount}
            sx={{ mx: "0.5rem" }}
            variant="contained"
          >
            Add Account
          </Button> */}
          <Button
            sx={{ mx: "0.5rem" }}
            onClick={openAddPayment}
            variant="contained"
          >
            Add Entry
          </Button>
          <Link to={"/accounting/register/approvals"}>
            <Button sx={{ mx: "0.5rem" }} variant="contained">
              Approve/Escalate
            </Button>
          </Link>
        </Stack>
      </Stack>
      <LoadingContent loading={loading}>
        <Stack
          direction={{ xs: "col", sm: "row" }}
          justifyContent="space-between"
          spacing={3}
          display={{ xs: "none", sm: "flex" }}
        >
          <Stack spacing={0} sx={{ width: { sm: "50%" } }}>
            <Typography sx={{ mb: 1, fontWeight: 700 }}>
              Income:{" "}
              <span style={{ color: "green" }}>
                ₹{accountStats.totalIncome}
              </span>
            </Typography>

            {incomes.length > 0 ? (
              incomes.map((expense) => (
                <IncomeCard
                  key={expense.id}
                  data={expense}
                  enqueueSnackbar={enqueueSnackbar}
                  refresh={refreshPage}
                />
              ))
            ) : (
              <Typography sx={{ textAlign: "center", py: 5 }}>
                No income entries
              </Typography>
            )}
          </Stack>
          <Stack spacing={0} sx={{ width: { sm: "50%" } }}>
            <Typography sx={{ mb: 1, ml: { sm: "auto" }, fontWeight: 700 }}>
              Expense :{" "}
              <span style={{ color: "red" }}>₹{accountStats.totalExpense}</span>{" "}
            </Typography>
            {expenses.length > 0 ? (
              expenses.map((expense) => (
                <ExpenseCard key={expense.id} data={expense} />
              ))
            ) : (
              <Typography sx={{ textAlign: "center", py: 5 }}>
                No expense entries
              </Typography>
            )}
          </Stack>
        </Stack>
        <Box display={{ sm: "none" }}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <ToggleButtonGroup
              color="primary"
              value={toggle}
              exclusive
              onChange={(_, val) => setToggle(val)}
            >
              <ToggleButton value="Income">Income</ToggleButton>
              <ToggleButton value="Expense">Expense</ToggleButton>
            </ToggleButtonGroup>
          </Box>

          {toggle === "Income" ? (
            <>
              {incomes.length > 0 ? (
                incomes.map((expense) => (
                  <IncomeCard
                    key={expense.id}
                    data={expense}
                    enqueueSnackbar={enqueueSnackbar}
                    refresh={refreshPage}
                  />
                ))
              ) : (
                <Typography sx={{ textAlign: "center", py: 5 }}>
                  No income entries
                </Typography>
              )}
            </>
          ) : (
            <>
              {expenses.length > 0 ? (
                expenses.map((expense) => (
                  <ExpenseCard key={expense.id} data={expense} />
                ))
              ) : (
                <Typography sx={{ textAlign: "center", py: 5 }}>
                  No expense entries
                </Typography>
              )}
            </>
          )}
        </Box>
      </LoadingContent>
      <AddPayment
        isOpen={addPaymentModal}
        close={closeAddPayment}
        refresh={fetchPayments}
      />
      {/* <AddAccount
        isOpen={addAccountModal}
        close={closeAddAccount}
        //refresh={}
      />
      <TransferBalance isOpen={transferBalance} close={closeTransferBalance} /> */}
    </>
  )
}

export default CashRegister
